// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-JrV","field":"styles_field__17zMK","fieldCol":"styles_fieldCol__a0_hd","diffCol":"styles_diffCol__hmbgh","diff":"styles_diff__fZF0k"};